import Component from './Monitor.vue';

export default {
  install(Vue) {
    Vue.component('BkfMonitor', Component);
  },
};
